export const REGIONS = [
    { code: 'A', name: 'East Midland' },
    { code: 'T', name: 'East' },
    { code: 'L', name: 'London' },
    { code: 'E', name: 'North East' },
    { code: 'N', name: 'North West' },
    { code: 'S', name: 'South East' },
    { code: 'W', name: 'South West' },
    { code: 'M', name: 'West Midlands' },
    { code: '[NEWATLSM]', name: 'England' },
    { code: 'X', name: 'Scotland' },
    { code: 'Y', name: 'Wales' },
    { code: '[NE]', name: 'English North Zone' },
    { code: '[MAT]', name: 'English Midland Zone' },
    { code: '[LSW]', name: 'English South Zone' },
    { code: '[MA]', name: 'English Midlands' },
];
